import { gql } from "@outschool/ui-apollo";

import EnrollmentPaymentFragment from "./EnrollmentPaymentFragment";
import EnrollmentPaymentRefundFragment from "./EnrollmentPaymentRefundFragment";

export const refundEnrollmentPaymentMutation = gql`
  mutation RefundEnrollment(
    $enrollmentPaymentUid: ID!
    $refundAmountCents: Int!
    $reducesTeacherPayout: Boolean!
    $refundReason: String!
    $refundNote: String!
    $refundType: RefundType
  ) {
    refundEnrollmentPayment(
      enrollmentPaymentUid: $enrollmentPaymentUid
      refundAmountCents: $refundAmountCents
      reducesTeacherPayout: $reducesTeacherPayout
      refundReason: $refundReason
      refundNote: $refundNote
      refundType: $refundType
    ) {
      ...EnrollmentPaymentFragment
      refunds {
        ...EnrollmentPaymentRefundFragment
      }
    }
  }
  ${EnrollmentPaymentFragment}
  ${EnrollmentPaymentRefundFragment}
`;

export const refundEnrollmentPaymentCreditsMutation = gql`
  mutation RefundEnrollmentCredits(
    $enrollmentPaymentUid: ID!
    $refundAmountCredits: Int!
    $reducesTeacherPayout: Boolean!
    $refundReason: String!
    $refundNote: String!
    $refundType: RefundType
  ) {
    refundEnrollmentPaymentCredits(
      enrollmentPaymentUid: $enrollmentPaymentUid
      refundAmountCredits: $refundAmountCredits
      reducesTeacherPayout: $reducesTeacherPayout
      refundReason: $refundReason
      refundNote: $refundNote
      refundType: $refundType
    ) {
      ...EnrollmentPaymentFragment
      refunds {
        ...EnrollmentPaymentRefundFragment
      }
    }
  }
  ${EnrollmentPaymentFragment}
  ${EnrollmentPaymentRefundFragment}
`;
